import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAdminAuth, formatApiErrorDetail } from "../../lib/admin-auth-context";

const STATUS = {
  new: { label: "Nueva", color: "blue" },
  contacted: { label: "Contactada", color: "amber" },
  won: { label: "Ganada", color: "green" },
  lost: { label: "Perdida", color: "red" },
};
const colors = {
  blue: "bg-blue-50 text-blue-700 border-blue-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  red: "bg-red-50 text-red-700 border-red-200",
};

export default function AdminQuotes() {
  const { api } = useAdminAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/quotes");
      setItems(res.data || []);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  const setStatus = async (q, status) => {
    try {
      await api.patch(`/quotes/${q.id}`, { status });
      toast.success("Estado actualizado");
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div data-testid="admin-quotes-page">
      <p className="text-xs tracking-[0.24em] uppercase font-bold text-[var(--icor-blue)] eyebrow-line">
        CRM
      </p>
      <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tighter mt-3 text-[var(--icor-navy)]">
        Cotizaciones recibidas
      </h1>
      <p className="text-slate-500 mt-2">
        Origen: formulario público del sitio. Asigna y actualiza estado.
      </p>

      <div
        className="mt-8 bg-white border border-slate-200 overflow-x-auto"
        style={{ borderRadius: 4 }}
      >
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-200">
              {["Fecha", "Nombre", "Empresa", "Email", "Estado", "Acciones"].map((h) => (
                <th
                  key={h}
                  className="text-left px-4 py-3 text-[10px] tracking-[0.2em] uppercase font-bold text-slate-500"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="px-4 py-8 text-center text-slate-400">Cargando…</td>
              </tr>
            ) : items.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-4 py-8 text-center text-slate-400">Sin cotizaciones aún.</td>
              </tr>
            ) : (
              items.map((q) => {
                const st = STATUS[q.status || "new"] || STATUS.new;
                return (
                  <tr
                    key={q.id}
                    data-testid={`quote-row-${q.id}`}
                    className="border-b border-slate-100"
                  >
                    <td className="px-4 py-3 whitespace-nowrap text-slate-600">
                      {new Date(q.created_at).toLocaleDateString("es-MX", {
                        day: "2-digit",
                        month: "short",
                      })}
                    </td>
                    <td className="px-4 py-3 font-medium text-[var(--icor-navy)]">
                      {q.name}
                      {q.products?.length > 0 && (
                        <div className="text-xs text-slate-500 mt-0.5">
                          {q.products.join(", ")}
                        </div>
                      )}
                    </td>
                    <td className="px-4 py-3 text-slate-600">{q.company || "—"}</td>
                    <td className="px-4 py-3 text-slate-600">{q.email}</td>
                    <td className="px-4 py-3">
                      <span
                        className={`inline-flex items-center px-2.5 py-1 text-[10px] tracking-[0.18em] uppercase font-bold border ${colors[st.color]}`}
                        style={{ borderRadius: 4 }}
                      >
                        {st.label}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <select
                        value={q.status || "new"}
                        onChange={(e) => setStatus(q, e.target.value)}
                        data-testid={`quote-status-${q.id}`}
                        className="text-xs border border-slate-200 px-2 py-1.5 outline-none focus:border-[var(--icor-blue)]"
                        style={{ borderRadius: 4 }}
                      >
                        {Object.entries(STATUS).map(([k, v]) => (
                          <option key={k} value={k}>
                            {v.label}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
